import { forwardRef, type Ref, type SVGProps } from "react";
const IconRotateClockwiseOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16.44 3.65a.97.97 0 0 1 0-1.367.955.955 0 0 1 1.357 0l2.612 2.63c.196.197.29.458.28.717a.97.97 0 0 1-.28.717l-2.612 2.63a.955.955 0 0 1-1.357 0 .97.97 0 0 1 0-1.367l1.034-1.041-5.873.018c-3.464.01-6.27 2.835-6.28 6.323l-.024 8.139a.963.963 0 0 1-.962.963.963.963 0 0 1-.957-.969l.024-8.138c.013-4.552 3.674-8.238 8.193-8.251l5.825-.018z" />
    <path
      fillRule="evenodd"
      d="M28.622 13.74c0-.91-.733-1.648-1.637-1.648h-14.51c-.904 0-1.636.738-1.636 1.648v14.612c0 .91.732 1.648 1.636 1.648h14.51c.904 0 1.637-.738 1.637-1.648zm-1.92 14.327V14.025H12.758v14.042z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(IconRotateClockwiseOutlineSVG);
ForwardRef.displayName = "IconRotateClockwiseOutline";
export { ForwardRef as IconRotateClockwiseOutline };
